// src/store/tierPickerManagment/types.ts
//
// Affichage seul : le choix effectif (résolution de la Promise ouverte par
// utils_tierPicker.pickTier) est tenu à part, dans une variable de module — Redux ne
// sait pas sérialiser une fonction de callback. Voir utils_tierPicker.ts.

export const OPEN_TIER_PICKER  = 'OPEN_TIER_PICKER';
export const CLOSE_TIER_PICKER = 'CLOSE_TIER_PICKER';

export interface PurchaseTier {
  variantCode : string;
  priceCode   : string;
  name        : string;  // ex. "2 devices"
  // Euros, TTC — PAS des centimes : vient de Product.variants[].prices[].priceWithTax
  // (api_product.ts, mapPrice), déjà converti de centimes en euros à la lecture du
  // catalogue. Rediviser par 100 à l'affichage a produit un bug réel (0,05 € au lieu de
  // 5,00 €, vu en achetant un device) — cf. TierPickerModal.tsx.
  priceWithTax: number;
  // Un même tier (ex. "1 device") peut exister en deux ProductVariant — un classique et
  // un récurrent (ProductVariant::recurringIntervalUnit côté API) — proposés côte à côte
  // ici plutôt que fusionnés : choisir "abonnement" ou "une fois" revient à choisir LE
  // variant, pas une option sur un variant unique.
  isRecurring:            boolean;
  recurringIntervalUnit:  string | null;  // 'month'|'year'|... — cf. BankProcessor_Stripe/Paypal
}

export interface TierPickerState {
  open : boolean;
  label: string;
  tiers: PurchaseTier[];
}

export const initialState: TierPickerState = {
  open : false,
  label: '',
  tiers: [],
};

export interface OpenTierPickerAction {
  type: typeof OPEN_TIER_PICKER;
  payload: {
    label: string;
    tiers: PurchaseTier[];
  };
}

export interface CloseTierPickerAction {
  type: typeof CLOSE_TIER_PICKER;
}

export type TierPickerActionTypes =
  | OpenTierPickerAction
  | CloseTierPickerAction;
